module.exports = __webpack_public_path__ + "static/img/边12.a4d2540.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/decorativePainting/imgs/边12.png
// module id = d+jL
// module chunks = 2